import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
export var ViewContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.calendar.viewContainer);
});
export var CalendarWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.calendar.maxWidth;
});